import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getFirstAnalyses,
  getFirstAnalysis,
  clearLocalFirstAnalyses,
  clearLocalActiveFirstAnalysis
} from './actions';

const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 }},
  firstAnalysis: { id: '', input: '', result: '', status: '', updated_at: '' },
  loading: { all: false, firstAnalysis: false }
};

const slice = createSlice({
  name: 'firstAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getFirstAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getFirstAnalyses.fulfilled, (state, action) => {
        const { first_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...first_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getFirstAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getFirstAnalysis.pending, (state) => {
        state.loading.firstAnalysis = true;
      })
      .addCase(getFirstAnalysis.fulfilled, (state, action) => {
        const { data: { first_analysis }, cable } = action.payload;
        const foundedFirstAnalysis = !!_find(state.all.data, (s) => s.id === first_analysis.id);
        const updatedFirstAnalysis = { ...state.firstAnalysis, ...first_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedFirstAnalysis ? _map(state.all.data, (e) => e.id === first_analysis.id ? { ...e, ...first_analysis } : e) : [...[first_analysis], ...oldAllData]; 
        const pagination = foundedFirstAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.firstAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedFirstAnalysis && !cable) state.firstAnalysis = updatedFirstAnalysis;       
      })
      .addCase(getFirstAnalysis.rejected, (state) => {
        state.loading.firstAnalysis = false;
      })
      .addCase(clearLocalFirstAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveFirstAnalysis, state => {
        state.firstAnalysis = initialState.firstAnalysis;
      })
  }
})

export default slice.reducer;